import styled from 'styled-components';
import { Typography } from '../../../../typography/Typography';

export const StartTypography = styled(Typography).withConfig({
    displayName: 'ContentPromotionStartTypography',
})``;
